import { Inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/user.model';
import { UserInfo } from '../models/userInfo.model';
import { loadIsForeignUserInfoUserInfoSuccess, loadUserInfoSuccess } from 'src/app/store/actions/userinfo.action';
import { Store } from '@ngrx/store';
import { selectIsForeignUserInfo, selectuserInfo } from 'src/app/store/selectors/userinfo.selectors';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly baseRoute: string;
  constructor(
    private readonly store: Store,
    private readonly httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.baseRoute = `${baseUrl}bff/`;
  }

  public getUserInfo(): Observable<User | undefined> {
    return this.httpClient
      .get<User>(`${this.baseRoute}userinfo`, {
        withCredentials: true
      })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((_) => of(undefined))
      );
  }

  public getUserDetails(): Observable<UserInfo | undefined> {
    return this.httpClient
      .get<UserInfo>(`${this.baseRoute}dol/userinfo?i=permissions`, {
        withCredentials: true
      })
      .pipe(
        map((userResponse: any) => {
          if (userResponse?.profile?.givenName) {
            this.store.dispatch(loadUserInfoSuccess({ userInfo: userResponse }));
            // Return the user response as UserInfo
            return userResponse as UserInfo;
          } else {
            // Return undefined if the response doesn't have expected fields
            return undefined;
          }
        }),
        catchError((_) => {
          // Return undefined in case of an error
          return of(undefined);
        })
      );
  }

  public getUserPermissions(): Promise<string[]> {
    return new Promise<string[]>((resolve) => {
      this.store.select(selectuserInfo).subscribe((response: UserInfo) => {
        resolve(response?.permissions || []);
      });
    });
  }

  public fetchUserInfo(): Observable<UserInfo> {
    return this.store.select(selectuserInfo).pipe((res) => {
      return res;
    });
  }

  public isForeignUser(): Observable<boolean | undefined> {
    return this.httpClient.get<boolean>(`${this.baseRoute}configuration/isForeignUser`).pipe(
      map((response: boolean) => {
        this.store.dispatch(loadIsForeignUserInfoUserInfoSuccess({ isForeignUser: response }));
        return response;
      }),
      catchError(() => of(undefined))
    );
  }

  public getIsForeignUserInfo(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.store.select(selectIsForeignUserInfo).subscribe((response: boolean) => {
        resolve(response);
      });
    });
  }
}
